<template>
  <div class="operation">
    <span
      class="first_line"
      @click.stop="operateCurrentNormalArticle(operateData, 'editor', $event)"
      v-if="
        operateData &&
        operateData.ctrl &&
        operateData.ctrl.role &&
        operateData.ctrl.role.edit
      "
    >
      <i class="iconfont icon-bianji"></i>
      <span>编辑</span>
    </span>

    <span
      class="first_line"
      v-if="
        operateData &&
        operateData.doc_type !== 'document' &&
        operateData.ctrl &&
        operateData.ctrl.role &&
        operateData.ctrl.role.use_req &&
        !operateData.flag_use
      "
      @click.stop="
        operateCurrentNormalArticle(operateData, 'useArticle', $event)
      "
    >
      <i class="iconfont icon-caiyong"></i>
      <span>采用</span>
    </span>

    <span
      class="first_line"
      v-if="
        operateData &&
        operateData.doc_type !== 'document' &&
        operateData.ctrl &&
        operateData.ctrl.role &&
        operateData.ctrl.role.use_req &&
        operateData.flag_use
      "
      @click.stop="
        operateCurrentNormalArticle(operateData, 'cancleuseArticle', $event)
      "
    >
      <i
        class="iconfont icon-weicaiyong"
        style="font-size: 14px"
      ></i>
      <span>取消采用</span>
    </span>

    <span
      class="first_line"
      v-if="
        operateData &&
        operateData.ctrl &&
        operateData.ctrl.role &&
        operateData.ctrl.role.audit_req &&
        operateData.audit_status !== 'doing'
      "
      @click.stop="
        operateCurrentNormalArticle(operateData, 'sendAudit', $event)
      "
    >
      <i class="iconfont icon-songshen"></i>
      <span>送审</span>
    </span>

    <span
      class="first_line"
      v-if="
        operateData &&
        operateData.ctrl &&
        operateData.ctrl.role &&
        operateData.ctrl.role.audit_fast &&
        operateData.audit_status !== 'doing'
      "
      @click.stop="
        operateCurrentNormalArticle(operateData, 'fastAudit', $event)
      "
    >
      <i class="iconfont icon-shenhe1"></i>
      <span>快速审核</span>
    </span>

    <span
      class="first_line"
      v-if="operateData && operateData.doc_type !== 'document' && operateData.doc_type !== 'outer_chain'"
      @click.stop="
        operateCurrentNormalArticle(operateData, 'previewApp', $event)
      "
    >
      <i class="iconfont icon-yulan1"></i>
      <span>预览</span>
    </span>

    <span
      class="first_line"
      v-if="
        operateData &&
        operateData.doc_type !== 'document' &&
        operateData.ctrl &&
        operateData.ctrl.role &&
        operateData.ctrl.role.push
      "
      @click.stop="operateCurrentNormalArticle(operateData, 'push', $event)"
    >
      <i class="iconfont icon-tuisong"></i>
      <span>推送</span>
    </span>

    <span
      class="first_line"
      v-if="
        operateData &&
        operateData.doc_type !== 'document' &&
        operateData.ctrl &&
        operateData.ctrl.role &&
        operateData.ctrl.role.push &&
        operateData.flag_push === 'yes'
      "
      @click.stop="
        operateCurrentNormalArticle(operateData, 'cancelpush', $event)
      "
    >
      <i class="iconfont icon-chexiao1"></i>
      <span>撤销推送</span>
    </span>

    <span
      class="first_line"
      @click.stop="operateCurrentNormalArticle(operateData, 'saveAs', $event)"
      v-if="
        operateData &&
        operateData.ctrl &&
        operateData.ctrl.role &&
        operateData.ctrl.role.copy_out
      "
    >
      <i class="iconfont icon-lingcun"></i>
      <span>另存</span>
    </span>

    <span
      class="first_line"
      @click.stop="checkArticleStatus(operateData, 'saveAsV2', $event)"
      v-if="
        operateData &&
        operateData.ctrl &&
        operateData.ctrl.role &&
        operateData.ctrl.role.submit_in
      "
    >
      <i class="el-icon-sell"></i>
      <span>投稿</span>
    </span>

    <span
      class="first_line"
      @click.stop="
        operateCurrentNormalArticle(operateData, 'submitArticle', $event)
      "
      v-if="
        operateData &&
        operateData.ctrl &&
        operateData.ctrl.role &&
        operateData.ctrl.role.submit_out
      "
    >
      <i class="iconfont icon-tougao"></i>
      <span>投递</span>
    </span>

    <span
      class="first_line"
      v-if="
        operateData &&
        operateData.doc_type !== 'document' &&
        operateData.ctrl &&
        operateData.ctrl.role &&
        operateData.ctrl.role.deprecate &&
        !operateData.flag_deprecate
      "
      @click.stop="
        operateCurrentNormalArticle(operateData, 'deprecate', $event)
      "
    >
      <i class="iconfont el-icon-document-remove"></i>
      <span>作废</span>
    </span>

    <span
      class="first_line"
      v-if="
        operateData &&
        operateData.doc_type !== 'document' &&
        operateData.ctrl &&
        operateData.ctrl.role &&
        operateData.ctrl.role.deprecate &&
        operateData.flag_deprecate
      "
      @click.stop="
        operateCurrentNormalArticle(operateData, 'cancledeprecate', $event)
      "
    >
      <i
        class="iconfont el-icon-document-remove"
        style="font-size: 14px"
      ></i>
      <span>取消作废</span>
    </span>

    <span class="first_line">
      <i class="iconfont icon-shenglvehao" />
      <span>更多</span>
      <div
        class="side_column"
        :class="[
          operateData.doc_type === 'picture' ? 'picture_side_column' : '',
        ]"
      >
        <ul>
          <li
            @click.stop="
              operateCurrentNormalArticle(operateData, 'deleteArticle', $event)
            "
            v-if="
              operateData &&
              operateData.ctrl &&
              operateData.ctrl.role &&
              operateData.ctrl.role.delete
            "
          >
            <i class="iconfont icon-huishouzhan1"></i>
            <span>删除</span>
          </li>
          <li
            @click.stop="
              operateCurrentNormalArticle(operateData, 'print', $event)
            "
            v-if="operateData && operateData.doc_type !== 'picture' && operateData.doc_type !== 'outer_chain'"
          >
            <i class="iconfont icon-ic-normal-dayin"></i>
            <span>打印</span>
          </li>
          <li
            @click.stop="
              operateCurrentNormalArticle(operateData, 'exportWord', $event)
            "
            v-if="operateData && operateData.doc_type !== 'picture' && operateData.doc_type !== 'outer_chain'"
          >
            <i class="iconfont icon-file-word-export"></i>
            <span>导出WORD</span>
          </li>
          <li
            v-if="
              operateData &&
              operateData.ctrl &&
              !operateData.ctrl.is_collect &&
              operateData.id_repo &&
              operateData.id_repo.indexOf('repository-personal') === -1
            "
            @click.stop="
              operateCurrentNormalArticle(operateData, 'collect', $event)
            "
          >
            <i class="iconfont icon-star-fill"></i>
            <span>收藏</span>
          </li>
          <li
            v-if="
              operateData &&
              operateData.ctrl &&
              operateData.ctrl.is_collect &&
              operateData.id_repo &&
              operateData.id_repo.indexOf('repository-personal') === -1
            "
            @click.stop="
              operateCurrentNormalArticle(operateData, 'cancleCollect', $event)
            "
          >
            <i class="iconfont icon-shoucang"></i>
            <span>取消收藏</span>
          </li>
          <li
            v-if="
              operateData &&
              operateData.ctrl &&
              operateData.ctrl.role &&
              operateData.ctrl.role.share &&
              operateData.doc_type !== 'picture' &&
              operateData.doc_type !== 'outer_chain'
            "
            @click.stop="
              operateCurrentNormalArticle(operateData, 'share', $event)
            "
          >
            <i class="iconfont icon-fenxiang"></i>
            <span>分享</span>
          </li>
          <li
            @click.stop="
              operateCurrentNormalArticle(operateData, 'move', $event)
            "
            v-if="
              operateData &&
              operateData.ctrl &&
              operateData.ctrl.role &&
              operateData.ctrl.role.move
            "
          >
            <i class="iconfont icon-yidong"></i>
            <span>移动</span>
          </li>

          <!-- <li ref='copy'
              data-clipboard-action="copy"
              data-clipboard-target="#news_text_copy"
              class="copy-link">复制</li> -->
        </ul>
      </div>
    </span>

    <div
      id="news_text_copy"
      v-html="copyHtml"
      style="position: absolute; left: 99999999px; top: 99999999999px"
    ></div>
  </div>
</template>

<script>
import * as api from "../../api";
import { download } from "../../helpers/exportFile";
import Clipboard from "clipboard";
import articleOperateMixins from "../../mixins/articleOperate";
export default {
  name: "operation",
  data () {
    return {
      copyBtn: null,
      copyHtml: "",
      currentOperateType: "",
    };
  },
  mixins: [articleOperateMixins],
  props: {
    operateData: {
      type: Object,
      required: true,
    },
  },
  created () { },
  components: {},
  computed: {},
  mounted () {
    this.getCopyHtml(this.operateData);
    // var _this = this
    // const clipboard = new Clipboard(".copy-link");
    // clipboard.on("success", function (e) {
    //   _this.$notify.success({
    //     title: '成功',
    //     message: '复制成功'
    //   });
    //   e.clearSelection();
    // });
    // clipboard.on("error", function (e) {
    //   _this.$notify.error({
    //     title: '失败',
    //     message: '复制失败'
    //   });
    //   e.clearSelection();
    // });
  },
  destroyed () { },
  methods: {
    operateCurrentNormalArticle (data, type, event) {
      this.operateCurrentArticles(data, type);
    },

    checkArticleStatus (data, type, event) {
      if (data.audit_status === "yes") {
        this.operateCurrentNormalArticle(data, type, event);
      } else {
        this.$notify.error({
          title: '错误!',
          message: '审核通过的稿件才能投稿!'
        });
      }
    },

    getCopyHtml (data) {
      // var option = {
      //   ...this.$store.getters.baseOption,
      //   'params': {
      //     "id_article": data.id,
      //   }
      // }
      // api._post(_API_ + 'api/article/utils/article_front_copy', option).then((res) => {
      //   if (res.code == 200) {
      //     this.copyHtml = res.data
      //   }
      // }).catch((error) => {
      //   console.log(error)
      // })
      console.log("获取复制内容");
    },
  },
  watch: {
    operateData () {
      if (this.operateData.hasOwnProperty("id")) {
        this.getCopyHtml(this.operateData);
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='stylus' scoped>
@import '../../styles/operatebutton.styl'
.picture_side_column
  left -100px !important
</style>
